import { css } from "@emotion/react";

const Footer: React.FC = () => {
  return (
    <div css={mainStyle}>
      <div css={containerStyle}>
        ©岡田和人(秋田書店) 　©2023「すんドめ」製作委員会
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const containerStyle = css`
  padding: 15px 0;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: bold;

  @media (max-width: ${spSize}px) {
    font-size: 10px;
  }
`;

export default Footer;
